import { setErrorLogParameter } from "./ComponentErrorLogAction";

const dispatchSetErrorLogParameter = (dispatch: Function) => (value:any) => {
    dispatch(setErrorLogParameter(value))
}
const ErrorLogDisptch = {
    dispatchSetErrorLogParameter
    
};

export default ErrorLogDisptch